'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactBootstrap = require('react-bootstrap');

var _ = require('./../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalFeedback = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ModalFeedback, _Component);

  function ModalFeedback() {
    (0, _classCallCheck3.default)(this, ModalFeedback);
    return (0, _possibleConstructorReturn3.default)(this, (ModalFeedback.__proto__ || (0, _getPrototypeOf2.default)(ModalFeedback)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModalFeedback, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isModalVisible = _props.isModalVisible,
          onModalHide = _props.onModalHide,
          err = _props.err,
          isLoading = _props.isLoading,
          handleSubmit = _props.handleSubmit,
          done = _props.done;


      if (done) {
        return _react2.default.createElement(
          _reactBootstrap.Modal,
          { className: 'modal-success', show: isModalVisible, onHide: onModalHide },
          _react2.default.createElement(_reactBootstrap.Modal.Header, { closeButton: true }),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-feedback-success-message' })
          )
        );
      }

      var formProps = {
        isLoading: isLoading,
        onSubmit: handleSubmit,
        err: err
      };

      return _react2.default.createElement(
        _reactBootstrap.Modal,
        { show: isModalVisible, onHide: onModalHide },
        _react2.default.createElement(
          _reactBootstrap.Modal.Header,
          { closeButton: true },
          _react2.default.createElement(
            _reactBootstrap.Modal.Title,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'modal-feedback-head' })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal.Body,
          null,
          _react2.default.createElement(_.FormFeedback, formProps)
        )
      );
    }
  }]);
  return ModalFeedback;
}(_react.Component), _class.propTypes = {
  done: _react.PropTypes.bool.isRequired,
  err: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
  handleSubmit: _react.PropTypes.func.isRequired,
  isLoading: _react.PropTypes.bool.isRequired,
  isModalVisible: _react.PropTypes.bool.isRequired,
  onModalHide: _react.PropTypes.func.isRequired
}, _temp);
exports.default = ModalFeedback;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ModalFeedback/ModalFeedback.js
 ** module id = 1231
 ** module chunks = 0
 **/